import gql from 'graphql-tag';

export default gql`
  mutation reassignRsvpRepVisit($input: reassignRsvpRepVisitInput!) {
    reassignRsvpRepVisit(input: $input) {
      viewer {
        id
        enabledFeatures
      }
    }
  }
`;
